module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticStyle: {
      "height": "550px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "text-center",
    staticStyle: {
      "padding-bottom": "50px",
      "padding-top": "10px"
    }
  }, [_c('img', {
    class: 'icon-doc-' + _vm.document.Type,
    staticStyle: {
      "width": "150px"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon",
    class: _vm.getStatusIcon(_vm.document.Status.toString()) + ' status-doc-' + _vm.document.Type
  })])], 1), _vm._v(" "), _c('b-row', _vm._l((_vm.fileArray), function(file) {
    return _c('b-col', {
      key: file.Name,
      staticClass: "form-group importFileButton text-left p-0",
      attrs: {
        "sm": "12"
      }
    }, [_c('span', {
      staticClass: "fileClickButton",
      on: {
        "click": function($event) {
          return _vm.downloadFile(file, $event)
        }
      }
    }, [_vm._v("\n        " + _vm._s(file.Name) + "\n      ")])])
  }), 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "id": "img_si_loupe"
    }
  }), _vm._v(" "), (_vm.hasOCRdata && _vm.editableStatus.includes('Doc_' + _vm.document.Status)) ? [(_vm.serializeGet.length != 0 && _vm.ocrDone) ? _c('b-row', _vm._l((_vm.serializeGet), function(value) {
    return _c('b-col', {
      key: value.name,
      staticClass: "form-group",
      attrs: {
        "sm": "12"
      }
    }, [_c('form-write-group-label-input', {
      attrs: {
        "horizontal": "",
        "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + value.name),
        "inputType": value.name === 'TypeIDCard' ? 'listeSelect' : 'text',
        "specificErrorIndicator": _vm.document.Serialize[value.name].Valid === '0',
        "warningIndicator": _vm.controlsConfig === '1' ? _vm.showWarningIndicator(value.name, _vm.document.Serialize) : false,
        "specificMessage": _vm.controlsConfig === '1' ? _vm.getAssociatedMessage(_vm.document.Serialize[value.name].Description) : ''
      },
      model: {
        value: (_vm.document.Serialize[value.name].Value),
        callback: function($$v) {
          _vm.$set(_vm.document.Serialize[value.name], "Value", $$v)
        },
        expression: "document.Serialize[value.name].Value"
      }
    }, [(value.name === 'TypeIDCard') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.document.Serialize[value.name]),
        expression: "document.Serialize[value.name]"
      }],
      staticClass: "form-control",
      class: {
        errorBorder: _vm.document.Serialize[value.name].Valid === '0'
      },
      attrs: {
        "id": "sel2",
        "readonly": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.document.Serialize, value.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('businessDocuments.slct_doct_type')))]), _vm._v(" "), _c('option', {
      domProps: {
        "value": _vm.$t('ocr.TypeIDCard.National_Identity_Card')
      }
    }, [_vm._v(_vm._s(_vm.$t('ocr.TypeIDCard.National_Identity_Card')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Passeport"
      }
    }, [_vm._v(_vm._s(_vm.$t('ocr.TypeIDCard.Passport')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Titre_sejour"
      }
    }, [_vm._v(_vm._s(_vm.$t('ocr.TypeIDCard.Titre_sejour')))])]) : _vm._e()])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [(_vm.showUploadFile(_vm.document)) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.openFileSelectionWindow($event)
      }
    }
  }, [_vm._v("\n          Upload\n        ")]), _vm._v(" "), _c('input', {
    ref: "fileButton",
    staticClass: "item-input hiddenElementAllSize local-file-input",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.executeOCR
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showEraseData(_vm.document)) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.reiniForm
    }
  }, [_vm._v("\n          Effacer\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.institutionalSourceableDocuments.includes(_vm.document.Type)) ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": function($event) {
        return _vm.callInstitutionalSource($event)
      }
    }
  }, [_vm._v("\n          Source\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "4"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.uploadDocument
    }
  }, [_vm._v("\n          Valider\n        ")])], 1)], 1)] : (_vm.document.Serialize) ? [_c('b-row', _vm._l((_vm.document.Serialize), function(info, index) {
    return _c('b-col', {
      key: index,
      staticClass: "form-group",
      attrs: {
        "sm": "12"
      }
    }, [_c('form-read-group-label-input', {
      attrs: {
        "horizontal": "",
        "inputLabel": _vm.$t('businessDocuments.serialize.' + _vm.document.Type + '.' + index),
        "inputValue": info
      }
    })], 1)
  }), 1)] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c6fa5ae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6fa5ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/DocumentBlocInfo.vue
// module id = 2449
// module chunks = 2